import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Box, Typography, Avatar, Container } from "@mui/material";
import { useState } from "react";

const Comments = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Container>
     <Typography
          sx={{
            textAlign: "center",
            fontSize: "1.8rem",
            mb: 10,mt:{lg:40,md:40,sm:30,xs:10}
          }}
        >
          {" "}
          <span
            style={{
              fontSize: "2.5rem",
              color: "#022a6b",
            }}
          >
            Clients
          </span>{" "}
          Review
        </Typography>

    <Carousel responsive={responsive} autoPlaySpeed={4000} infinite={true} 

    autoPlay={true}
   >
   <div>
            <Box
              sx={{
                
                borderRadius: 15,
                maxWidth: "80%",
                alignItems: "center",
                margin: "auto",
                paddingBottom: 4,
                
            
              }}
            >
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <Avatar
                  src="cap.avif"
                  sx={{
                    width: 100,
                    height: 100,
                    boxShadow:24,
                    border: "4px solid white",
                    
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  width: "50%",
                  margin: "auto",
                  mt: 2,
                }}
              >
                I absolutely love shopping at this store! The quality of their
                clothing is fantastic, and they always have the latest trends.
                The staff is super friendly and helpful too. Highly recommend!
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "#022a6b",
                  mt: 2,
                 
                }}
              >
                Sikshya Rijal
              </Typography>
            </Box>
          </div>
          <div>
            <Box
              sx={{
                
                borderRadius: 15,
                maxWidth: "80%",
                alignItems: "center",
                margin: "auto",
                paddingBottom: 4,
                
              }}
            >
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <Avatar
                  src="hot.jpg"
                  sx={{
                    width: 100,
                    height: 100,
                    boxShadow:24,
                    border: "4px solid white",
                    
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  width: "50%",
                  margin: "auto",
                  mt: 2,
                }}
              >
                Great experience every time I visit this store. The variety of
                styles and sizes they offer is impressive. Prices are
                reasonable, and the clothes are well-made. Will definitely be
                back!
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "#022a6b",
                  mt: 2,
                  
                }}
              >
                Hari sapkota
              </Typography>
            </Box>
          </div>
          <div>
            <Box
              sx={{
                
                borderRadius: 15,
                maxWidth: "80%",
                alignItems: "center",
                margin: "auto",
                paddingBottom: 4,
                
              }}
            >
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <Avatar
                  src="cap.avif"
                  sx={{
                    width: 100,
                    height: 100,
                    boxShadow:24,
                    border: "4px solid white",
                    
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  width: "50%",
                  margin: "auto",
                  mt: 2,
                }}
              >
                This store has become my go-to for all my clothing needs. Their
                online ordering process is seamless, and the shipping is fast.
                I've never been disappointed with my purchases. 5 stars!
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "#022a6b",
                  mt: 2,
                 
                }}
              >
                Ram Gautam
              </Typography>
            </Box>
          </div>
          <div>
            <Box
              sx={{
                
                borderRadius: 15,
                maxWidth: "80%",
                alignItems: "center",
                margin: "auto",
                paddingBottom: 4,
                
              }}
            >
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <Avatar
                  src="hot.jpg"
                  sx={{
                    width: 100,
                    height: 100,
                    boxShadow:24,
                    border: "4px solid white",
                    
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  width: "60%",
                  margin: "auto",
                  mt: 2,
                }}
              >
                I recently discovered this store, and I'm glad I did! Their
                customer service is top-notch, and they go above and beyond to
                ensure customer satisfaction. The quality of their clothing is
                excellent for the price.
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "#022a6b",
                  mt: 2,
                 
                }}
              >
                Nischal Karki
              </Typography>
            </Box>
          </div>
          <div>
            <Box
              sx={{
               
                borderRadius: 15,
                maxWidth: "80%",
                alignItems: "center",
                margin: "auto",
                paddingBottom: 4
                
              }}
            >
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <Avatar
                  src="cap.avif"
                  sx={{
                    width: 100,
                    height: 100,
                 boxShadow:24,
                    border: "4px solid white",
                    
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  width: "60%",
                  margin: "auto",
                  mt: 2,
                }}
              >
                I've been shopping here for years, and I'm always impressed by
                the selection and the level of service. Whether I'm looking for
                casual wear or something more formal, I can always find what I
                need. Love this store!
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.3rem",
                  color: "#022a6b",
                  mt: 2,
                
                }}
              >
                Rabina sapkota
              </Typography>
            </Box>
          </div>
     
    </Carousel></Container>
  );
};

export default Comments;
